<template>
  <nav class="breadcrumb-group" aria-label="Breadcrumb">
    <ol>
      <li v-for="(item, index) in items" :key="index">
        <Breadcrumb
          :label="item.label"
          :disabled="item.disabled"
          :isCurrent="index === items.length - 1"
          :maxLength="maxLength"
        />
      </li>
    </ol>
  </nav>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Breadcrumb from './Breadcrumb.vue';

interface BreadcrumbItem {
  label: string;
  disabled?: boolean;
}

export default defineComponent({
  name: 'BreadcrumbGroup',

  components: {
    Breadcrumb,
  },

  props: {
    items: {
      type: Array as () => BreadcrumbItem[],
      required: true,
      validator: (items: BreadcrumbItem[]) =>
        items.every(item => typeof item === 'object' && 'label' in item),
    },
    maxLength: {
      type: Number,
      default: 20,
    },
  },

  setup() {
    return {};
  },
});
</script>

<style scoped>
.breadcrumb-group {
  display: flex;
  align-items: center;
  padding: 20px;
}

ol {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

li {
  display: flex;
  align-items: center;
}
</style>
